import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { STORE_KEYS } from 'countable@helpers';
import { GenericResModel } from 'countable@model';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EngagementStore {
  public checklistData$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  private dataMap = new Map<STORE_KEYS, any>();
  private dataStore: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();

  constructor(private httpClient: HttpClient) { }

  setData(input: STORE_KEYS, data: any) {
    if (!this.dataStore.has(input)) {
      this.dataStore.set(input, new BehaviorSubject<any>(null));
    }
    this.dataStore.get(input)?.next(data);
    this.dataMap.set(input, data);
  }

  getData(input: STORE_KEYS): Observable<any> {
    if (!this.dataStore.has(input)) {
      this.dataStore.set(input, new BehaviorSubject<any>(null));
    }
    return this.dataStore.get(input)?.asObservable();
  }

  hasData(input: STORE_KEYS): boolean {
    return this.dataMap.has(input) && (this.dataMap.get(input) !== null);
  }

  getStoreKeyValue(input: STORE_KEYS) {
    return this.dataStore.get(input)?.getValue();
  }

  getCheckListData(subModuleId: number, MasterChecklistId?: number) {
    let Master_checklist_id = MasterChecklistId ? MasterChecklistId : null;
    this.checklistData$.next(undefined);

    this.getCheckListObjective(subModuleId, Master_checklist_id).pipe(
      tap(res => {
        if (res?.status === 200 && JSON.parse(res?.data)?.length) {
          let headerData = JSON.parse(res?.data)[0].objective;
          headerData = headerData?.trim();
          this.checklistData$.next(headerData);
        } else {
          this.checklistData$.next(undefined);
        }
      })
    ).subscribe();
  }

  public getCheckListObjective(subModuleId: number, masterChecklistId?: string | number): Observable<GenericResModel<string>> {
    const param = {
      'subModuleId': subModuleId
    };
    if (masterChecklistId && masterChecklistId != 'null') {
      param['masterCheckListId'] = masterChecklistId;
    }
    return this.httpClient.get<GenericResModel<string>>(environment.apiV2 + '/firm/check-list-objective', {params: param});
  }
}
